import React, {Component} from 'react';
import {Form, DatePicker, Input, Select, Col, Checkbox, Row} from 'antd';
import {reqGetVendorsPlusDelete} from "../../../api";
import {COMPONENT_JOB_TYPE, STATUS_COMPONENT} from "../../../utils/const";
import moment from 'moment';
import _ from 'lodash';
import {regexMoney} from "../../../utils/utility";
import LinkButton from "../../LinkButton";
import SelectInput from '../../SelectInput';

const {Item} = Form;
const {Option} = Select;
const {TextArea} = Input;

class Edit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      vendors: [],
    };
    props.setForm(this.props.form)
  }

  componentDidMount() {
    //get all vendors by type
    reqGetVendorsPlusDelete({searchName: 'component', searchType: 'type'})
      .then(response => {
        const vendors = response.data;
        this.setState({vendors});
      })
      .catch(error => {
        console.log(error.response)
      });
  }

  onChange = (value) => {
    if (value === 'Stone Deposit') {
      this.props.form.setFieldsValue({description: "Transferrable and refundable deposit to bring in/ hold stones."});
    }else if(value === 'Ring Registry'){
      this.props.form.setFieldsValue({description: "-hand drawn sketch \n-can be used as credit once ready to proceed to the final design"});
      this.props.form.setFieldsValue({retail: 150});
    }else if(value === 'Ring Registry Credit'){
      this.props.form.setFieldsValue({retail: -150});
    }else if(value === 'Resin Registry'){
      this.props.form.setFieldsValue({description: "-CAD/3D printed resin \n-can be used as credit once ready to proceed to the final design"});
      this.props.form.setFieldsValue({retail: 500});
    }else if(value === 'Resin Registry Credit'){
      this.props.form.setFieldsValue({retail: -500});
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      description,
      start_date,
      requires_approval_repair,
      approved_repair,
      retail,
      vendor_id,
      status,
      job_type
    } = this.props.order_item;
    const {vendors} = this.state;

    return (
      <Form>
        <Row>
          <Col span={21}>
            <Item label="Job Type" labelCol={{span: 5}} wrapperCol={{span: 15}}>
              {getFieldDecorator('job_type', {
                initialValue: job_type || '',
                rules: [
                  {required: true, message: 'Job Type is required'},
                  {max: 40, message: 'Maximum 40 characters'}
                ]
              })(
                <SelectInput options={COMPONENT_JOB_TYPE} onChange={this.onChange}/>
              )}
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={21}>
            <Item label="Description" labelCol={{span: 5}} wrapperCol={{span: 15}}>
              {
                getFieldDecorator('description', {
                  initialValue: description || '', //add or update
                })(
                  <TextArea rows={4}/>
                )
              }
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Item label='Retail' labelCol={{span: 9}} wrapperCol={{span: 12}}>
              {
                getFieldDecorator('retail', {
                  initialValue: retail || '',
                  rules: [
                    {required: true, message: 'retail is required'},
                    {
                      pattern: regexMoney,
                      message: 'Number with 2 decimal places Only',
                    }
                  ]
                })(<Input/>)
              }
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Item label="Require Repair/Component" labelCol={{span: 14}} wrapperCol={{span: 8}}>
              {getFieldDecorator('requires_approval_repair', {
                initialValue: requires_approval_repair || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
          <Col span={12}>
            <Item label="Approve Repair/Component" labelCol={{span: 14}} wrapperCol={{span: 8}}>
              {getFieldDecorator('approved_repair', {
                initialValue: approved_repair || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
        </Row>
        {
          !(_.isEmpty(this.props.order_item)) &&
          (
            <React.Fragment>
              <Row>
                <Col span={12}>
                  <Item label="Vendor" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {getFieldDecorator('vendor_id', {
                      initialValue: vendor_id || '',
                    })(
                      <Select
                        showSearch
                        filterOption={(inputValue, option) =>
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      >
                        {
                          vendors.map(item => <Option hidden={!!item.deleted_at} value={item.id}
                                                      key={item.id}> {item.name} </Option>)
                        }
                      </Select>
                    )}
                  </Item>
                </Col>
                <Col span={12}>
                  <Item label="Start Date" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {
                      getFieldDecorator('start_date', {
                        initialValue: !(start_date) ? null : moment(start_date),
                      })(
                        <DatePicker/>
                      )
                    }
                  </Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Item label="Status" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {getFieldDecorator('status', {
                      initialValue: status || '',
                    })(
                      <Select>
                        {
                          STATUS_COMPONENT.map(item => <Option value={item} key={item}> {item} </Option>)
                        }
                      </Select>
                    )}
                  </Item>
                </Col>
              </Row>
              <Row>
                {!!vendor_id && <LinkButton onClick={() => this.props.deletePO()}>DELETE PO#</LinkButton>}
              </Row>
            </React.Fragment>
          )
        }
      </Form>
    )
  }
}

export default Form.create()(Edit)